import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { RiPencilFill } from "react-icons/ri";
import PageHeader from '../../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
import SubscriberFieldsAddAndEditModal from './components/SubscriberFieldsAddAndEditModal';
import { useSubscriberFieldsData } from './hooks/useSubscriber';
import { FaEdit } from 'react-icons/fa';


const SubscriberFieldsColumns = (handleEditSubscriberField: (row: any) => void) => [
    {
        name: "Field Name",
        selector: (row: { FieldName: string }) => row.FieldName || '-',
        sortable: true,
        width: '40%',
        wrap:true
    },
    {
        name: "Field Type",
        selector: (row: { FieldType: string }) => row.FieldType || '-',
        sortable: true,
        width: '40%',
        wrap:true
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center">
                <button
                    onClick={() => handleEditSubscriberField(row)}
                    className="btn btn-primary"
                    style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                >
                    <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
                </button>
            </div>
        ),
    },
]



const SubscriberFields = () => {
    const location = useLocation();
    const { subscriberRowData } = location?.state || {};
    // console.log('subscriberRowData', subscriberRowData?.SubscriberTypeId)
    const [paginationStates, setPaginationStates] = useState<any>({
        limit: 10,
        page: 1,
        search: null,
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [rowData, setRowData] = useState(null)
    const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
    const { data } = useSubscriberFieldsData({
        typeId: subscriberRowData?.SubscriberTypeId,
        enable: true, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            search: paginationStates.search,
        }
    })

    const handleEditSubscriberField = (row:any) => {
        setRowData(row)
        setCheckAddEditStatus('Edit')
        setIsModalOpen(true)
    }
    const toggleModal = () => {
        setCheckAddEditStatus('Add')
        setIsModalOpen(true);
    }
    const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };
    const handleSearch = (searchValue: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                search: searchValue,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };

    // console.log('dataOfFieldssss', data?.data)

    return (
        <div
            className="p-4"
        >
            <PageHeader
                title="Subscriber"
                buttons={[
                    {
                        label: "+ Add Subscriber Field",
                        onClick: toggleModal,
                        color: "#2e8dd3",
                    },

                ]}
            />
            <BasicDataTable
                paginationTotalRows={data?.data?.recordsTotal || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                handleSearch={(val: any) => { handleSearch(val) }}
                Title="Subscriber Fields"
                columns={SubscriberFieldsColumns(handleEditSubscriberField)}
                data={data?.data?.data || []}
            />
            <SubscriberFieldsAddAndEditModal rowData={rowData} SubscriberTypeId={subscriberRowData?.SubscriberTypeId} setCheckAddEditStatus={setCheckAddEditStatus} checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add Subscriber Field' : 'Edit Subscriber Field'} />
        </div>
    )
}

export default SubscriberFields
